import { render, staticRenderFns } from "./OverlayGameAds.vue?vue&type=template&id=aff07212&"
import script from "./OverlayGameAds.vue?vue&type=script&lang=ts&"
export * from "./OverlayGameAds.vue?vue&type=script&lang=ts&"
import style0 from "./OverlayGameAds.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports